// Third party imports
import { createSlice } from "@reduxjs/toolkit";

export const myBoardSlice = createSlice({
  name: "myBoard",
  initialState: {
    tasks: [],
    selectedTask: null,
    subtasks: [],
    selectedSubtask: null,
    loading: false,
    loadingMore: false,
    error: null,
    pagination: {
      next: null,
      previous: null,
      count: 0,
      hasMore: false,
    },
  },
  reducers: {
    setTasks: (state, action) => {
      state.tasks = action.payload;
    },
    setSelectedTask: (state, action) => {
      state.selectedTask = action.payload;
    },
    clearSelectedTask: (state) => {
      state.selectedTask = null;
    },
    clearTasks: (state) => {
      state.tasks = [];
    },
    setSubtasks: (state, action) => {
      state.subtasks = action.payload;
    },
    appendSubtasks: (state, action) => {
      state.subtasks = [...state.subtasks, ...action.payload];
    },
    addSubtask: (state, action) => {
      state.subtasks.push(action.payload);
    },
    updateSubtask: (state, action) => {
      const index = state.subtasks.findIndex(
        (subtask) => subtask.id === action.payload.id
      );
      if (index !== -1) {
        state.subtasks[index] = action.payload;
      } else {
        // If subtask is not in the list, add it (for activation case)
        state.subtasks.push(action.payload);
      }
      // Also update selectedSubtask if it's the same subtask
      if (state.selectedSubtask?.id === action.payload.id) {
        state.selectedSubtask = action.payload;
      }
    },
    removeSubtask: (state, action) => {
      state.subtasks = state.subtasks.filter(
        (subtask) => subtask.id !== action.payload
      );
    },
    updateTask: (state, action) => {
      const index = state.tasks.findIndex(
        (task) => task.id === action.payload.id
      );
      if (index !== -1) {
        state.tasks[index] = action.payload;
      } else {
        // If task is not in the list, add it (for activation case)
        state.tasks.push(action.payload);
      }
      // Also update selectedTask if it's the same task
      if (state.selectedTask?.id === action.payload.id) {
        state.selectedTask = action.payload;
      }
    },
    removeTask: (state, action) => {
      state.tasks = state.tasks.filter(
        (task) => task.id !== action.payload
      );
      // Clear selected task if it was removed
      if (state.selectedTask?.id === action.payload) {
        state.selectedTask = null;
      }
    },
    setSelectedSubtask: (state, action) => {
      state.selectedSubtask = action.payload;
    },
    clearSelectedSubtask: (state) => {
      state.selectedSubtask = null;
    },
    clearSubtasks: (state) => {
      state.subtasks = [];
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setLoadingMore: (state, action) => {
      state.loadingMore = action.payload;
    },
    setPagination: (state, action) => {
      state.pagination = {
        next: action.payload.next,
        previous: action.payload.previous,
        count: action.payload.count,
        hasMore: action.payload.next !== null,
      };
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
});

export const {
  setTasks,
  setSelectedTask,
  clearSelectedTask,
  clearTasks,
  setSubtasks,
  appendSubtasks,
  addSubtask,
  updateSubtask,
  removeSubtask,
  updateTask,
  removeTask,
  setSelectedSubtask,
  clearSelectedSubtask,
  clearSubtasks,
  setLoading,
  setLoadingMore,
  setPagination,
  setError,
  clearError,
} = myBoardSlice.actions;

export default myBoardSlice.reducer;
